import { DeviceType } from "@finbackoffice/enums";
import { ConfigContextV2 } from "contexts";
import { useOrientationChange } from "hooks/base/useOrientation";
import { useScreenWidth } from "hooks/base/useScreenWidth";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { DESKTOP_SCREEN_WIDTH } from "utils/constants";

export const useDevice = () => {
    const { deviceType } = useContext(ConfigContextV2);
    const screenWidth = useScreenWidth();
    const [deviceInfo, setDeviceInfo] = useState({ isTouchDevice: false });
    const isMobileDeviceMemo = useMemo(() => deviceType === DeviceType.Mobile, [deviceType]);

    const checkDevice = useCallback(() => {
        if (typeof window === "undefined") {
            setDeviceInfo({ isTouchDevice: false });
            return;
        }

        const isTouchDevice =
            "ontouchstart" in window ||
            navigator.maxTouchPoints > 0 ||
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            navigator.msMaxTouchPoints > 0;

        setDeviceInfo({
            isTouchDevice,
        });
    }, []);

    useEffect(() => {
        checkDevice();
    }, [checkDevice]);

    useOrientationChange(checkDevice, true);

    return useMemo(
        () => ({
            isMobileDevice: isMobileDeviceMemo,
            screenWidth,
            ...deviceInfo,
            isDesktopScreenWidth: screenWidth >= DESKTOP_SCREEN_WIDTH,
        }),
        [deviceInfo, isMobileDeviceMemo, screenWidth],
    );
};
